import { gql } from '@apollo/client';

export const DataRefreshMetaFieldsFragment = gql`
  fragment DataRefreshMetaFields on DataRefreshMeta {
    latestRefreshAt
    refreshState
  }
`;
